<template>
  <section id="carousel">
    <div class="row mt-5 d-sm-none">
      <div class="col-12 text-center">
        <span class="get-your-loan section-title">
          Consigue un<br>crédito para...
        </span>
      </div>
    </div>
    <div class="row mt-5 d-none d-sm-inline-flex w-100">
      <div class="col-8 col-md-6 text-left">
        <span class="get-your-loan section-title">
          Consigue un<br>crédito para...
        </span>
      </div>
      <div class="col-1">
        <div class="w-100" style="position: relative; bottom: -65px; float: left; top: 25px;">
          <img src="@/assets/arrows/curved-arrow.svg" style="width: 100%; min-width: 74px">
        </div>
      </div>
    </div>

    <div class="row mt-5 mb-2">
      <swiper class="swiper" :options="swiperOption" ref="bigCarousel">
          <swiper-slide>
            <div class="get-your-loan-for"
                 v-bind:style="{ 'background-image': 'url('+require('@/assets/illustrations/cash.svg')+')'}"
            >
            </div>
            <div class="text-center get-your-loan-pills">
              <div class="get-your-loan-pills-header">Libre inversión</div>
              <div class="get-your-loan-pills-text">&nbsp;</div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="get-your-loan-for"
                 v-bind:style="{ 'background-image': 'url('+require('@/assets/illustrations/llantas.svg')+')'}"
            >
            </div>
            <div class="text-center get-your-loan-pills">
              <div class="get-your-loan-pills-header">{{ replacements }}</div>
              <div class="get-your-loan-pills-text">&nbsp;</div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="get-your-loan-for"
                 v-bind:style="{ 'background-image': 'url('+require('@/assets/illustrations/celulares2.svg')+')'}"
            >
            </div>
            <div class="text-center get-your-loan-pills">
              <div class="get-your-loan-pills-header">Celulares</div>
              <div class="get-your-loan-pills-text">Consigue tu celular</div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="get-your-loan-for"
                 v-bind:style="{ 'background-image': 'url('+require('@/assets/illustrations/fast-repair.svg')+')'}"
            >
            </div>
            <div class="text-center get-your-loan-pills">
              <div class="get-your-loan-pills-header">Mecánica</div>
              <div class="get-your-loan-pills-text">&nbsp;</div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="get-your-loan-for"
                 v-bind:style="{ 'background-image': 'url('+require('@/assets/illustrations/electrodomesticos.svg')+')'}"
            >
            </div>
            <div class="text-center get-your-loan-pills">
              <div class="get-your-loan-pills-header">Electrodomésticos</div>
              <div class="get-your-loan-pills-text">TV, lavadora, frigorífico, etc.</div>
            </div>
          </swiper-slide>
          <swiper-slide v-if="showWorkWear">
            <div class="get-your-loan-for"
                 v-bind:style="{ 'background-image': 'url('+require('@/assets/illustrations/mochila-y-ropa.svg')+')'}"
            >
            </div>
            <div class="text-center get-your-loan-pills">
              <div class="get-your-loan-pills-header" style="display: inline-block; margin: 0 auto; max-width: 200px">Mochila y ropa de trabajo</div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>

    <get-your-credit-button :form-url="formUrl" :sold-out="soldOut"></get-your-credit-button>

    <div class="row">
      <div class="col-xs-12 text-center mb-5 col-sm-8 offset-sm-2 col-md-6 offset-md-3 col-lg-4 offset-lg-4 col-xl-4 offset-xl-4">
        <span class="get-your-loan-text">
          ¡Ofrecemos la tasa de interés<br>más <span class="underline-green fw-bold">baja del mercado!</span>
        </span>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable */
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
  import 'swiper/swiper.min.css'
  import GetYourCreditButton from './partials/GetYourCreditButton'
  export default {
    name: 'ProductSlider',
    title: 'Product carousel',
    props: {
      formUrl: '',
      replacements: {
        type: String,
        default: 'Repuestos'
      },
      showWorkWear: {
        type: Boolean,
        default: true
      },
      soldOut: {
        type: Boolean,
        default: false
      }
    },
    components: {
      Swiper,
      SwiperSlide,
      GetYourCreditButton
    },
    data() {
      return {
        swiperOption: {
          slidesPerView: 3,
          centeredSlides: true,
          spaceBetween: 30,
          pagination: {
            el: '.swiper-pagination',
            type: 'fraction'
          },
          breakpoints: {
            1400: {
              slidesPerView: 5,
              spaceBetween: 45
            },
            1200: {
              slidesPerView: 4,
              spaceBetween: 45
            },
            992: {
              slidesPerView: 4,
              spaceBetween: 5
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 20
            },
            576: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            0: {
              slidesPerView: 1,
              spaceBetween: 0
            }
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }
      }
    },
    methods: {
      toSlide(index) {
        this.$refs.bigCarousel.$swiper.slideTo(index, 0)
      }
    }
  }
</script>

<style>
.get-your-loan-for {
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
  height: 166px;
  width: auto;
  margin-left: 10px;
  margin-right: 10px;
}
.get-your-loan-pills {
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
  padding-top: 10px;
  padding-bottom: 10px;
  width: auto;
  border-left: 1px solid lightgrey;
  border-right: 1px;
  border-bottom: 1px;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.21);
  max-height: 68px
}
@media (max-width: 768px) {
  .get-your-loan-for {
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
    height: 207px;
    width: 270px;
    margin-left: 0px;
    margin-right: 0px;
    background-size: 100%;
  }

  .get-your-loan-pills {
    border-bottom-left-radius: 7px;
    border-bottom-right-radius: 7px;
    padding-top: 10px;
    padding-bottom: 10px;
    width: 270px;
    border-left: 1px solid lightgrey;
    border-right: 1px;
    border-bottom: 1px;
    margin-left: 0px;
    margin-right: 0px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.21);
  }
}
@media (max-width: 575px) {
  .swiper-container {
    max-width: 310px;
  }
}
.get-your-loan-pills-header {
  color: #333333;
  font-family: "Source Serif Pro";
  font-size: 1.2rem;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 24px;
}
.get-your-loan-pills-text {
  color: #333333;
  font-size: 0.9rem;
  letter-spacing: 0;
  line-height: 24px;
}
.get-your-loan-text {
  height: 48px;
  width: 253px;
  color: #777777;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
}
.VueCarousel-inner {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/ProductSlider.vue